import { useCallback, useState } from 'react'
import { useFindStockPersonalWithTransitMutation } from '../../SliceLogistica'
import { StockPersonalENTITY } from 'sigo-entities'
import { useSelector } from 'react-redux'
import { RootState } from '../../AdapterStore'
import { useStockPersonalEquiposRepository } from './useStockPersonalEquiposRepository'
import { indexedDB } from '../../useIndexedDB'

interface Params {
    pipeline: any[]
}

export const useStockPersonalRepository = (loadEquipment?: boolean) => {
    const { user } = useSelector((state: RootState) => state.auth)

    const [findStockPersonalWithTransit, { isError, error }] = useFindStockPersonalWithTransitMutation()
    const { findStockPersonalEquipos, isError: isErrorFindStock, error: errorFindStock } = useStockPersonalEquiposRepository()

    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState<StockPersonalENTITY[]>([])

    const loadData = useCallback(async ({ pipeline }: Params) => {
        setIsLoading(true)
        try {
            // ONLINE
            if (navigator.onLine) {
                const response = await findStockPersonalWithTransit({
                    pais: user.Pais.Codigo,
                    delegacion: user.Delegacion.Codigo,
                    pipeline
                }).unwrap()
                const now = Date.now()

                await indexedDB.stock_personal.clear()
                await indexedDB.stock_personal.bulkPut(response.map(item => ({
                    ...item,
                    pendingSync: 0,
                    updatedAt: now,
                    syncedAt: now
                })))

                if (loadEquipment) {
                    const pipeline = [{
                        $match: {
                            ID_StockPersonal: {
                                $in: response.map(item => item.ID_StockPersonal)
                            }
                        }
                    }]
                    await findStockPersonalEquipos({ pipeline })
                }

                setData(response)
                return response
            }
            // OFFLINE
            const localData = await indexedDB.stock_personal.toArray()
            setData(localData)
            return localData
        } finally {
            setIsLoading(false)
        }
    }, [findStockPersonalWithTransit, findStockPersonalEquipos])

    return {
        data,
        isLoading,
        loadData,
        isError: isError || isErrorFindStock,
        error: error || errorFindStock
    }
}